<template>
  <v-container fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12">
        <v-toolbar color="white" flat>
          <v-toolbar-title class="text-h5">平台类型</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-actions class="pb-0 px-4">
            <v-subheader class="px-0">平台类型列表</v-subheader>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click.stop="AddApp(null)"> <v-icon left>mdi-plus</v-icon>新增 </v-btn>
          </v-card-actions>
          <v-card-text>
            <v-data-table show-expand :expanded.sync="expanded" :headers="headers" :items="platTypeList" item-key="name" :items-per-page="100" class="elevation-1 table-expanded-style">
              <template v-slot:[`item.appIdRequired`]="{ item }">
                <span v-if="item.appIdRequired === 1" class="mdi mdi-check mdi-24px text-success"></span>
              </template>
              <template v-slot:[`item.routingParameters`]="{ item }">
                <span v-if="item.routingParameters === 1" class="mdi mdi-check mdi-24px text-success"></span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
                <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">删除</v-btn>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="table-expanded-content">
                  <p>
                    <span class="text-h5">{{ item.name }}</span
                    >子平台
                    <v-btn outlined small color="primary" @click.stop="AddApp(item.code)"> <v-icon left>mdi-plus</v-icon>新增子平台 </v-btn>
                  </p>
                  <v-data-table v-if="item.children.length > 0" :headers="headers" :items="item.children" class="elevation-1">
                    <template v-slot:[`item.routingParameters`]="{ item }">
                      <span v-if="item.routingParameters === 1" class="mdi mdi-check mdi-24px text-success"></span>
                    </template>
                    <template v-slot:[`item.appIdRequired`]="{ item }">
                      <span v-if="item.appIdRequired === 1" class="mdi mdi-check mdi-24px text-success"></span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-btn class="ma-2 white--text" small outlined color="blue" @click="clickAction(item, 'edit')">编辑</v-btn>
                      <v-btn class="ma-2 white--text" small outlined color="error" @click="clickAction(item, 'delete')">删除</v-btn>
                    </template>
                  </v-data-table>
                  <p v-else class="grey--text">暂无子平台数据</p>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">删除类型</span>
        </v-card-title>
        <v-card-text class="pb-0"> 确定要删除该类型？<br /> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ isEdit ? "编辑" : "新增" }}平台类型</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="form" v-model="valid">
            <v-text-field v-model="form.code" :rules="rules.code" label="code" required></v-text-field>
            <v-text-field v-model="form.name" :rules="rules.name" label="名称" required></v-text-field>
            <v-checkbox v-model="form.routingParameters" :true-value="1" :false-value="0" label="是否需要配置route"></v-checkbox>
            <v-checkbox v-model="form.appIdRequired" :true-value="1" :false-value="0" label="是否需要配置Appid"></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="addDialog = false" text>取消</v-btn>
          <v-btn color="primary" :disabled="!valid" @click="addSubmit" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
export default {
  name: 'AppInfo',
  components: {
  },
  data () {
    return {
      headers: [
        { text: 'code', value: 'code', width: '100px' },
        { text: '名称', value: 'name', width: '150px' },
        { text: '是否需要配置route', value: 'routingParameters', width: '100px' },
        { text: '是否需要配置Appid', value: 'appIdRequired', width: '100px' },
        { text: '操作', value: 'actions', width: '100px' },
        { text: '', value: 'data-table-expand' }
      ],
      desserts: [],
      appList: [],
      deleteDialog: false,
      addDialog: false,
      isEdit: false,
      currentItem: {},
      valid: false,
      rules: {
        code: [
          v => !!v || '请填写code'
        ],
        name: [
          v => !!v || '请填写名称'
        ]
      },
      form: {
        code: '',
        name: '',
        appIdRequired: 0,
        routingParameters: 0,
        parentCode: null
      },
      defaultAppIcon: 'this.src="' + require('@/assets/icon/example.svg') + '"',
      expanded: []
    }
  },
  computed: {
    ...mapState(['platTypeList'])
  },
  created () {
  },
  methods: {
    AddApp (code) {
      this.form = {
        code: '',
        name: '',
        appIdRequired: 0,
        parentCode: code
      }
      this.addDialog = true
    },
    // action
    clickAction (item, type) {
      this.currentItem = item
      if (type === 'edit') {
        this.isEdit = true
        this.addDialog = true
        this.form = item
      } else if (type === 'delete') {
        this.isEdit = false
        this.deleteDialog = true
      }
    },
    // add & edit
    addSubmit () {
      console.log(this.form)
      const request = buildAxios()
      if (!this.isEdit) {
        request.post('basePlatInfo/add', this.form).then(res => {
          this.addDialog = false
          this.$store.dispatch('getPlatType')
        }).catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
      } else {
        request.post('basePlatInfo/update', this.form).then(res => {
          this.addDialog = false
          this.$store.dispatch('getPlatType')
        }).catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
      }
    },
    // delete
    deleteItem () {
      const request = buildAxios()
      request.post('basePlatInfo/delete', { code: this.currentItem.code }).then(res => {
        this.deleteDialog = false
        this.$store.dispatch('getPlatType')
      }).catch(reason => {
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  },
  filters: {
  }
}
</script>
